/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
/* Styles */
import styles from "./styles.js"


const Content = ({ selectedCompany, companies, onChange }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.modalContent}>
      {
        companies && companies.map(item => (
          <div key={item?.companyEntityID} className="form-check">
            <input
              onChange={() => onChange(item)}
              className={`form-check-input ${classes.checkbox}`}
              type="radio"
              name="company"
              id={`company${item?.companyEntityID}`}
              checked={selectedCompany?.companyEntityID === item?.companyEntityID ? "checked" : ""}
            />
            <label className="form-check-label" htmlFor={`company${item?.companyEntityID}`}>
              { item.companyName }
            </label>
          </div>
        ))
      }
    </div>
  )
}

export default Content;
